export default function shallowEquals(a: object, b: object, ignoreFunctions: boolean = false) {
  for (const p in a) {
    if (!(p in b)) {
      return false;
    }
  }
  for (const p in b) {
    if (ignoreFunctions && typeof (a as any)[p] === 'function' && typeof (b as any)[p] === 'function') {
      continue;
    }
    if (!(p in a) || (a as any)[p] !== (b as any)[p]) {
      return false;
    }
  }
  return true;
}
